import React, {Component} from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import get from "lodash/get";
import compose from "lodash/flowRight";
import {withApollo} from "react-apollo";
import {string} from "yup";
import {clearAuth} from "shared/Auth/actions/authActions";
import Auth from "shared/Auth/auth";
import SubmitButton from "shared/Experimental/Forms/components/SubmitButton/SubmitButton";
import Form from "shared/Experimental/Forms/components/Form/Form";
import FormGroup from "shared/Experimental/Forms/components/FormGroup/FormGroup";
import TextInput from "shared/Experimental/Forms/components/TextInput/TextInput";
import s from "./Login.pcss";
import PageTitle from "../../shared/components/PageTitle/PageTitle";
import {Panel, PanelBody} from "../../shared/components/Panel";
import ErrorMessage from "../../../shared/Experimental/Forms/components/ErrorMessage/ErrorMessage";

export class LoginComponent extends Component {
    async handleSubmit(values, actions) {
        try {
            await Auth.login(
                this.props.client,
                this.props.authState,
                this.props.dispatch,
                values.email,
                values.password,
                get(this.props, "location.pathname"),
                "ABRA_URL",
                true,
            );
            actions.setSubmitting(false);
            // error handling
            if (!Auth.loggedIn(this.props.authState)) {
                actions.setFieldError("serverError", "Either username or password is wrong");
            } else {
                const isUniversity = Auth.loggedIn(this.props.authState, "university");
                if (!isUniversity) {
                    actions.setFieldError("serverError", "Only university users can login here.");
                    this.props.dispatch(clearAuth());
                } else {
                    const {hostname} = window.location;
                    const isUITest = hostname === "127.0.0.1" || hostname === "localhost";
                    if (isUITest) {
                        this.props.history.replace("/blank");
                    } else {
                        this.props.history.replace("/");
                    }
                }
            }
        } catch (error) {
            actions.setSubmitting(false);
            const message = get(error, "graphQLErrors[0].message");
            if (message.includes("locked")) this.props.history.push("/auth/reset/accountlocked");
            else actions.setFieldError("serverError", message);
        }
    }

    render() {
        return (
            <div className={s.container}>
                <PageTitle
                    className={s.title}
                    title="Unibuddy University Login"
                    skipLinkId="main-content"
                />
                <Panel>
                    <PanelBody>
                        <Form
                            id="login-form"
                            data-test-id="login-form"
                            initialValues={{email: "", password: "", serverError: ""}}
                            validationSchema={{
                                email: string()
                                    .email()
                                    .required(),
                                password: string().required(),
                            }}
                            onSubmit={this.handleSubmit.bind(this)}
                        >
                            <FormGroup id="email" label="Email">
                                <TextInput name="email" type="email" placeholder="Email Address" />
                            </FormGroup>

                            <FormGroup id="password" label="Password">
                                <TextInput name="password" type="password" placeholder="Password" />
                            </FormGroup>
                            <SubmitButton block color="primary" id="login" type="submit">
                                Login
                            </SubmitButton>
                            <ErrorMessage className={s.serverError} name="serverError" />
                            <hr />
                            <div className="text-right">
                                <Link id="resetPassword" to="/auth/reset">
                                    Forgot your password?
                                </Link>
                            </div>
                        </Form>
                    </PanelBody>
                </Panel>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    authState: state.authState,
    me: state.authState.me,
});

export default compose(
    connect(mapStateToProps),
    withApollo,
)(LoginComponent);
